var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgPinkBokunLogo = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "pink-bokun-logo",
    "data-name": "pink-bokun-logo",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 74.32 33.28",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".pink-bokun-logo-cls-1{fill:#f065a2;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "pink-bokun-logo-cls-1",
    d: "M45.74,64.86a1.12,1.12,0,0,0-1.12-1.1H41.18V66h3.17a1.41,1.41,0,0,0,1-.34A1.1,1.1,0,0,0,45.74,64.86Zm-4.56-6.69v2.15h2.1A1.31,1.31,0,0,0,44.2,60a1.1,1.1,0,0,0,.32-.77,1.06,1.06,0,0,0-1.07-1.06Zm9.07,6.69a4.58,4.58,0,0,1-1.34,3.28A5.06,5.06,0,0,1,45,69.52H37.09V54.79l6.74,0a4.57,4.57,0,0,1,3.75,1.34,4.17,4.17,0,0,1,1.11,3.12,2.69,2.69,0,0,1-.66,2,1.52,1.52,0,0,1,.88.45A4.28,4.28,0,0,1,50.25,64.86Z",
    transform: "translate(-37.09 -36.84)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "pink-bokun-logo-cls-1",
    d: "M96.28,54.79v9a6.11,6.11,0,0,1-1.86,4.49,6.41,6.41,0,0,1-9,0,6.11,6.11,0,0,1-1.86-4.49v-9h4.62v9a1.77,1.77,0,0,0,3.53,0v-9Z",
    transform: "translate(-37.09 -36.84)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "pink-bokun-logo-cls-1",
    d: "M106.79,54.77v6.72L102,54.77l-4.6,0V69.52H102v-6.8l4.77,6.82,0,0h4.56V54.77Z",
    transform: "translate(-37.09 -36.84)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "pink-bokun-logo-cls-1",
    d: "M82.39,54.77H76.57l-4,5.1v-5.1H67.94V69.52h4.62v-5.1l4,5.1h5.82l-5.62-7.38Z",
    transform: "translate(-37.09 -36.84)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "pink-bokun-logo-cls-1",
    d: "M61.22,59.85a3.18,3.18,0,0,0-2.35-1,3.23,3.23,0,0,0-2.38,1,3.18,3.18,0,0,0-1,2.34,3.28,3.28,0,0,0,1,2.36,3.32,3.32,0,0,0,2.38,1,3.27,3.27,0,0,0,2.35-1,3.13,3.13,0,0,0,1-2.36A3,3,0,0,0,61.22,59.85Zm3.28,7.93a8,8,0,0,1-11.26,0A7.93,7.93,0,0,1,64.5,56.6a7.82,7.82,0,0,1,0,11.18Z",
    transform: "translate(-37.09 -36.84)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "pink-bokun-logo-cls-1",
    d: "M90.37,36.84h0l-8.26,8.33,1-1.52L81.8,42.41,78.72,45l-1.55-.5-9,8.12h43l-1.93-1.4-7.5-6.48-5.33,3.11L100,45.43Zm-7.81,9.57,7.74-7.85,3.33,4.37a11.94,11.94,0,0,0-1.92-.86h0c-.12.13-3,3.61-3,3.61l-.16-2L88,44.78l-.08-1Zm-1.31-2.47-1,2.1L80,45.73l-3,3.35s0-.44,0-.6,0,0,0,0a4.2,4.2,0,0,0-.91.34l.93-1.94-1.94.42,2.46-1.91.9.93Zm15.49,4.87,5.17-3,2.36,1.9-1.39,0-1,1.08,0-1.33-5.07,1.31Z",
    transform: "translate(-37.09 -36.84)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "pink-bokun-logo-cls-1",
    d: "M63.45,49.28,60,52.61H57L60,49.28Z",
    transform: "translate(-37.09 -36.84)"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgPinkBokunLogo);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/pink-bokun-logo.d8eba6b8cbef169b11deb63588204989.svg";